import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from "./Header";
import HeroSection from "./HeroSection";
import Join from './Join';
import ReportsSection from './ReportsSection';
import ArticlesSection from './ArticlesSection';
import Contact from './Contact';
import Footer from './Footer';

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollTo = (location.state as any)?.scrollTo;
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location.state]);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ReportsSection />
        <ArticlesSection />
        <Join />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
